import { useMutation, useQueryClient } from 'react-query';
import { ParticipantService } from '../../services/wealthlane-customer-services';

const useGetMaskingDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setDobValue?: (value: string) => void | null,
  setSsnValue?: (value: string) => void | null
): any => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: { type?: string; id?: string }) => {
      if (payload?.type === 'DOB') {
        return await handleRequest(
          ParticipantService.getApiCustomerApiAppParticipantDateOfBirthByParticipantId(payload?.id)
        );
      } else if (payload?.type === 'SSN') {
        return await handleRequest(
          ParticipantService.getApiCustomerApiAppParticipantSocialSecurityNumberByParticipantId(
            payload?.id
          )
        );
      }
    },
    {
      onSuccess: (response: any, payload: { type?: string; id?: string }) => {
        payload?.type === 'DOB'
          ? setDobValue && setDobValue(response)
          : setSsnValue && setSsnValue(response);
        queryClient.invalidateQueries('getParticipantPersonalDetails');
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default useGetMaskingDetails;
